// Missing route/ETA metrics are unavailable, while numeric zero is meaningful.
export const parseNullableNonNegativeMetric = value => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};

export const sumRequiredMetrics = (rows, field) => {
  let total = 0;
  for (const row of rows) {
    const value = parseNullableNonNegativeMetric(row[field]);
    if (value === null) return null;
    total += value;
  }
  return total;
};
